import {SimulatorInterface} from "../../services/interface/simulator/simulator-interface";

export const SimulatorMock: SimulatorInterface[] = [
    {value: 3000, time: '3 Meses'},
    {value: 3500, time: '6 Meses'},
    {value: 4000, time: '9 Meses'},
    {value: 4500, time: '12 Meses'},
]
